import { namespace as createVuexClass } from 'vuex-class';

export const namespace = 'checker';
export const store = createVuexClass(namespace);

export const CHECK_VEHICLE_INFO_COMPATIBILITY = 'checkVehicleInfoCompatibility';
export const CHECK_COMPATIBILITY_DDD = 'checkCompatibilityDdd';
export const CHECK_COMPATIBILITY_BY_MODEL = 'checkCompatibilityByModel';
export const CHECK_COMPATIBILITY_BATCH = 'checkCompatibilityBatch';
